export default __webpack_public_path__ + "static/media/fav-32x32.409a9fdb.png";